import React from "react";
import "./SearchPromptInput.scss";
import searchIcon from "../Home/img/search.png";
import subscribeImg from "./img/subscribe.png";
import subscribedImg from "./img/subscribed.png";

// Cvanto Search Phase 7 — this is ONLY the ordinary search input now. It
// never triggers Cvanto AI Search in any way (no send-to-AI button, no mic,
// no "listening" state) — that entire flow moved into its own component,
// CvantoAISearchModal, opened exclusively via the orb in SearchHero. Plain
// typing keeps firing `onChange` (SearchResults' own existing debounced
// ordinary-search path, untouched); Enter stays ordinary search via
// `onKeyDown`.
const SearchPromptInput = React.forwardRef(
  (
    {
      value,
      onChange,
      onKeyDown,
      onClear,
      placeholder = "Що шукаєте?",
      category,
      subscribed,
      subBusy,
      subAnim,
      onToggleSub,
    },
    ref,
  ) => {
    const trimmed = String(value || "").trim();
    const showClear = trimmed.length > 0;

    return (
      <div className="cvanto-prompt-row">
        <div className="cvanto-prompt-input">
          <img className="cvanto-prompt-input__icon" src={searchIcon} alt="" />

          <input
            ref={ref}
            type="text"
            placeholder={placeholder}
            className="cvanto-prompt-input__field"
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onKeyDown={onKeyDown}
          />

          {showClear && (
            <button
              type="button"
              className="cvanto-prompt-input__clear"
              onClick={onClear}
              aria-label="Очистити"
            >
              ×
            </button>
          )}
        </div>

        {category && (
          <button
            className={[
              "search-category-sub-btn",
              subscribed ? "is-on" : "is-off",
              subBusy ? "is-busy" : "",
              subAnim === "on" ? "animate-on" : "",
              subAnim === "off" ? "animate-off" : "",
            ]
              .join(" ")
              .trim()}
            onClick={onToggleSub}
            disabled={subBusy}
            aria-label={
              subscribed ? `Ви підписані на ${category}` : `Підписатись на ${category}`
            }
            title={subscribed ? `Ви підписані на ${category}` : `Підписатись на ${category}`}
            type="button"
          >
            <img src={subscribed ? subscribedImg : subscribeImg} alt="" draggable={false} />
          </button>
        )}
      </div>
    );
  },
);

export default SearchPromptInput;
